export const DEFAULT_ITEM_SIZE = 4
export const UNIT = 19.05
export const BASE_SIZE = 18
export const BASE_RADIUS = 1.5
export const DISH_SIZE = 12
export const DISH_RADIUS = 2
